<template>
    <div id="dmm_ntgnavi">
        <ul class="navi_left">
            <li class="dmm_top mg-l12"><a href="http://www.dmm.com/"><img src="https://www.dmm.com/images/netgame/navi/dmm_logo.gif" alt="DMM.com"></a></li>
            <li class="ntg_top"><a href="http://www.dmm.com/netgame/"><span>DMM GAMESトップ</span></a></li>
            <li class="ntg_poi"><a href="https://point.dmm.com/choice/pay?basket_service_type=freegame" target="_blank"><span>ポイントチャージ</span></a></li>
        </ul>
    <ul class="navi_right">
        <li><a href="http://www.dmm.com/netgame/top/guide/startguide_html/=/ch_navi=/" class="arrow">初めての方</a></li>
    </ul>
    <div class="clear"></div>
    <!-- [[ end of "dmm_ntgnavi" ]] --></div>
</template>

<script>
export default {

}
</script>

<style scoped>
#dmm_ntgnavi {
    background: url(~@/assets/images/bg_navimain.gif) center center repeat-x;
    border-bottom: 1px solid #ccc;
    border-top: 1px solid #ccc;
    font-size: 12px;
}
#dmm_ntgnavi ul {
    list-style: none;
    margin: 2px 0;
    padding: 0;
}
#dmm_ntgnavi ul li {
    float: left;
    margin: 0 6px 0 0;
    line-height: 15px;
}
#dmm_ntgnavi ul.navi_left { float: left }
#dmm_ntgnavi ul.navi_left li > a {
    display: block;
    padding: 0 3px 0 8px;
    text-decoration: none;
    border: 1px solid #eee;
    border-radius: 3px;
}
#dmm_ntgnavi ul.navi_left li > a:hover {
    background: #eee;
    border: 1px solid #666;
    border-radius: 3px;
}
#dmm_ntgnavi ul.navi_left li > a span {
    display: block;
    padding: 9px 10px 7px 28px;
    color: #333;
    font-weight: bold;
}
#dmm_ntgnavi ul.navi_left li.dmm_top img { margin: 8px 5px 8px 0 }
#dmm_ntgnavi ul.navi_left li.ntg_top span { background: url(~@/assets/images/bg_bt_olgtop.gif) 0 center no-repeat }
#dmm_ntgnavi ul.navi_left li.ntg_brw span { background: url(~@/assets/images/bg_bt_brows.gif) 0 center no-repeat }
#dmm_ntgnavi ul.navi_left li.ntg_min span { background: url(~@/assets/images/bg_bt_mini.gif) 0 center no-repeat }
#dmm_ntgnavi ul.navi_left li.ntg_poi span { background: url(~@/assets/images/bg_bt_point.gif) 0 center no-repeat }
#dmm_ntgnavi ul.navi_left li.ntg_chip span { background: url(~@/assets/images/bg_bt_chip.gif) 0 center no-repeat }
#dmm_ntgnavi ul.navi_right {
    float: right;
    font-size: 10px;
}
#dmm_ntgnavi ul.navi_right li {
    margin: 0 10px 0 0;
    padding: 8px 5px;
}
#dmm_ntgnavi .arrow {
    padding-left: 14px;
    background: url(~@/assets/images/arrow_common.gif) no-repeat left center;
}
#dmm_ntgnavi .tx-point {
    font-size: 16px;
    font-weight: bold;
    color: #ff4b4b !important;
}
#dmm_ntgnavi p {
margin: 0;
line-height:2.6em;
}
#dmm_ntgnavi .clear {clear: both;}
#dmm_ntgnavi .mg-l12 {margin-left: 12px;}
#dmm_ntgnavi .mg-r12 {margin-right: 12px;}
#dmm_ntgnavi .pd-t12 {padding-top: 12px;}
</style>